/** Security tab: script slugs, sections, and display labels. */

export const SECURITY_SECTIONS = [
  {
    id: 'threat-protection',
    title: 'Threat protection',
    description: 'Windows Defender, ThreatDown, and Office macro policy.',
  },
  {
    id: 'network',
    title: 'Firewall & DNS posture',
    description: 'Scored here for the traffic light; full firewall and DNS detail is on the Network tab.',
  },
  {
    id: 'encryption-boot',
    title: 'Encryption & boot',
    description: 'BitLocker, TPM, and Secure Boot.',
  },
  {
    id: 'system-health',
    title: 'System health',
    description:
      'End-of-life .NET 6 runtimes. Winget availability is on the Software tab; pending reboot is under Toolkit health on Overview.',
  },
  {
    id: 'access',
    title: 'Access (PAM-lite)',
    description:
      'Local administrators and membership changes. Failed logins are listed here but do not set Action needed.',
  },
]

/** Snapshot script slugs grouped by Security tab section. */
export const SNAPSHOT_SECTION_SLUGS = {
  'threat-protection': ['office-macros'],
  network: [], // DNS + firewall evaluated for posture; UI lives on Network tab
  'encryption-boot': ['bitlocker', 'tpm-secureboot'],
  'system-health': [],
  access: ['local-admins'],
}

/** Event script slugs grouped by Security tab section. */
export const EVENT_SECTION_SLUGS = {
  'threat-protection': ['defender-detections'],
  access: ['failed-logins', 'local-admin-changes'],
}

export const SNAPSHOT_TITLES = {
  bitlocker: 'BitLocker',
  'disk-space': 'Disk space',
  'windows-firewall': 'Windows Firewall',
  'network-adapters': 'Network adapters',
  'dhcp-dns-health': 'DHCP and DNS server health',
  'pending-reboot': 'Pending reboot',
  'tpm-secureboot': 'TPM & Secure Boot',
  'local-admins': 'Local administrators',
  'defender-dns': 'Windows Defender',
  'office-macros': 'Office macros',
}

export const DEFENDER_FIELDS = {
  defender_status: 'Defender status',
  defender_antivirus: 'Antivirus',
  defender_realtime: 'Real-time protection',
  defender_last_scan: 'Last scan',
  defender_signature_age: 'Signature age',
  defender_threats: 'Threats',
}

export const DNS_FIELDS = {
  dns1: 'DNS 1',
  dns2: 'DNS 2',
}

export function snapshotTitle(slug, apiTitle) {
  return apiTitle || SNAPSHOT_TITLES[slug] || slug
}

export function sectionForSnapshot(slug) {
  for (const [sectionId, slugs] of Object.entries(SNAPSHOT_SECTION_SLUGS)) {
    if (slugs.includes(slug)) return sectionId
  }
  if (slug === 'defender-dns') return 'threat-protection'
  return null
}

export function sectionForEvent(slug) {
  for (const [sectionId, slugs] of Object.entries(EVENT_SECTION_SLUGS)) {
    if (slugs.includes(slug)) return sectionId
  }
  return null
}
